import { useState, useCallback } from 'react'
import { Button, Grid, Slider, Typography } from '@mui/material'
import FlexibleWidthDialog from 'components/Dialog/FlexibleWidthDialog'
import Cropper from 'react-easy-crop'
import { useTranslation } from 'react-i18next';
import getCroppedImg from '../helpers/CroppedHelpers';

export default function CropImage({ open, image, imageMetadata, close, returnImageCropped }) {
  const { t } = useTranslation();
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
    console.log(croppedArea, croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels,
        rotation
      )
      console.log('donee', { croppedImage: URL.createObjectURL(croppedImage) })
      returnImageCropped(new File([croppedImage], imageMetadata.name, { type: imageMetadata.type }))
      setCroppedImage(croppedImage)
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation])

  return (
    <FlexibleWidthDialog maxWidth="lg" open={open} title="Eliminación de imagen"
      actions={<Button onClick={close}>{t('button_text_cancel')}</Button>}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <div style={{ position: "relative", height: 300 }}>
            <Cropper
              image={image}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={16 / 9}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
          <div>
            <div>
              <Typography variant="overline"> Zoom </Typography>
              <Slider
                value={zoom}
                min={1}
                max={10}
                step={0.1}
                aria-labelledby="Zoom"
                onChange={(e, zoom) => setZoom(zoom)}
              />
            </div>
            <div>
              <Typography variant="overline" > Rotación </Typography>
              <Slider
                value={rotation}
                min={0}
                max={360}
                step={1}
                aria-labelledby="Rotation"
                onChange={(e, rotation) => setRotation(rotation)}
              />
            </div>
            <Button onClick={showCroppedImage} variant="contained" color="primary">
              Guardar ajuste
            </Button>
          </div>
        </Grid>
      </Grid>
    </FlexibleWidthDialog>
  )
}